<template>
  <div class="fixed inset-0 z-[100] flex items-center justify-center p-4">
    <div class="w-full max-w-md rounded-xl border border-gray-700 bg-gray-900 p-6 shadow-2xl">
      <h3 class="text-xl font-bold text-white">{{ title }}</h3>

      <p v-if="description" class="mt-2 text-sm text-gray-300">{{ description }}</p>

      <template v-if="mode === 'progress'">
        <div class="mt-4 h-3 w-full overflow-hidden rounded bg-gray-700">
          <div
            class="h-full bg-blue-500 transition-all duration-100"
            :style="{ width: `${progressPercent}%` }"
          ></div>
        </div>
        <p class="mt-2 text-sm text-gray-300">{{ secondsRemaining }}s remaining</p>
      </template>

      <div v-else-if="mode === 'confirm'" class="mt-6 flex justify-end gap-2">
        <AppButton variant="outline" @click="$emit('cancel')">Cancel</AppButton>
        <AppButton variant="primary" @click="$emit('confirm')">Start Calibration</AppButton>
      </div>

      <div v-else-if="mode === 'complete'" class="mt-6 flex justify-end">
        <AppButton variant="primary" @click="$emit('ok')">OK</AppButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import AppButton from './AppButton.vue';

defineProps({
  mode: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    default: ''
  },
  progressPercent: {
    type: Number,
    default: 0
  },
  secondsRemaining: {
    type: Number,
    default: 0
  }
});

defineEmits(['cancel', 'confirm', 'ok']);
</script>
